module.exports = __webpack_public_path__ + "static/media/slider_img4.4ee12d28.jpg";